export default () => {
  const select = document.querySelector('.js-blog-terms-select')

  if (! select ) return

  // set chosen option
  const query = window.location.search

  if (query.includes('thema')) {
    for(let i = 0; i < select.length; i++) {
      let option = select[i];

      if (option.value == query) {
        select.selectedIndex = i
      }
    }
  }

  // if choose an option > add value to the url and refresh
  select.addEventListener('change', () => {  
    let current_choice = select.options[select.selectedIndex].value
    window.location.href = current_choice + '#top'
    // NOTE: set target (#top) to prevent jumping to bottom of the page
  })
}


// WEBPACK FOOTER //
// ./src/js/modules/BlogTermsSelect.js